import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'idba-filter-field',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, ReactiveFormsModule, FormsModule],
  templateUrl: './filter-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './filter-field.component.scss'
})
export class FilterFieldComponent {
  value: string = '';
  somenteAtivos: boolean = true;

  @Input() showSomenteAtivos: boolean = false;
  @Input() somenteAtivosLabel: string = 'Somente Ativos';
  @Input() disabled: boolean = false;
  @Output() filter = new EventEmitter<string>();
  @Output() somenteAtivosChange = new EventEmitter<boolean>();

  @Input('somenteAtivos')
  set somenteAtivosInput(value: boolean) {
    this.somenteAtivos = value;
  }

  applyFilter(value: string): void {
    this.filter.emit(value.trim().toLowerCase());
  }

  applySomenteAtivos(value: boolean): void {
    this.somenteAtivos = value;
    this.somenteAtivosChange.emit(this.somenteAtivos);
  }

  setValue(newValue: string): void {
    this.value = newValue;
  }

}
